module.exports = __webpack_public_path__ + "img/score_02.6cc694e2.svg";